import { getWalletExtraHomeShowConfig } from '@/business/wallet-area';
import { CustomException } from '@tencent/ppd-base-libs';
import { to } from '@tencent/wphk-base-utils';
import isFunction from 'lodash-es/isFunction';
import { onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';
import { HomeShowConfigItem, beforeHomeShowConfig as staticBeforeHomeShowConfig } from '../config/home-show-config';

/** 根据spId或merchantId找到目标配置 */
const getConfigById = ({ spId, merchantId, configList }:
{ spId: string, merchantId: string, configList: HomeShowConfigItem[] }) => {
  let config: HomeShowConfigItem|undefined;
  if (spId) {
    // 优先用spId查
    config = configList.find(item => item.spId === spId);
  }
  if (!config) {
    // 如果找不到config, 则用merchantId查
    config = configList.find(item => item.merchantId === merchantId);
  }
  return config;
};

/**
 * Home页面各个展示阶段的钩子，支持根据不同商户执行自定义函数。
 * 目前只支持了home页面展示之前的钩子
 */
export const useHomeShow = () => {
  const router = useRouter();
  let beforeHomeShowConfig = staticBeforeHomeShowConfig;
  onBeforeMount(() => {
    // 预加载额外的homeShow配置
    getWalletExtraHomeShowConfig();
  });
  /** home页面展示之前的钩子 */
  const beforeHomeShow = async ({ merchantId, spId }: { merchantId: string, spId: string }) => {
    // 处理额外添加的homeShow配置
    const [, walletExtraConfig] = await to(getWalletExtraHomeShowConfig());
    beforeHomeShowConfig = beforeHomeShowConfig.concat(walletExtraConfig);
    const config = getConfigById({ spId, merchantId, configList: beforeHomeShowConfig });
    if (config?.func && isFunction(config?.func)) {
      const [err, res] = await to(config?.func(config, { router }));
      if (!err) {
        return { isContinue: res?.isContinue };
      }
      new CustomException(err, 'execBeforeHomeShowFail', '执行页面展示前钩子失败');
    }
    // 不阻断home页面执行
    return { isContinue: true };
  };
  return {
    beforeHomeShow,
  };
};
